'use strict';

/* Controllers */

app.controller('MenuController', ['$scope', '$rootScope', '$location', '$timeout', 'ngDialog', 'Menu', 'Venue', 'Drink', 'Helper', 'User', 'Popup', 
    function ($scope, $rootScope, $location, $timeout, ngDialog, Menu, Venue, Drink, Helper, User, Popup) {

        // pass service to scope
        $scope.User = User;
        $scope.Drink = Drink;

    	// init scope vars
    	$scope.categories = [];
        $scope.currency_symbol = $rootScope.globals.selectedVenue.currency_symbol+' ';
        $scope.selected_users_username = $rootScope.globals.selectedUser.username;
        $scope.selectedUser = $rootScope.globals.selectedUser;
        $scope.selectedVenue = $rootScope.globals.selectedVenue;
        $scope.selected_user_is_checked_in = User.isCheckedIn($scope.selectedUser);


    	/**
    	 * infinit scroll triggers this function
    	 * to get more search results
    	 */
    	$scope.getDrinks = function(){

    		// get more results
    		Menu.getDrinks($rootScope.globals.selectedVenue, function(resp, status){

    			if( status == 200){
		    		$scope.categories = resp.data.drinks;

                    if(resp.data.drinks == null){
        				Popup.error('Selected venue doesn\'t have any drinks.');
                    }
                }
                else if( status != 500 ){
                    Popup.error(Helper.getProperty(resp, 'data.message'));
                }else{
                    Popup.error('Something went wrong :(');
    			}

    			getting_more_results = false;
    		});
    	}


    	/**
    	 * select drink from results
    	 * 
    	 * @param Object  drink
    	 */
    	$scope.selectDrink = function(drink, category_icon){
            // add selected drink to root scope
            $rootScope.globals.selectedDrink = drink;
            $rootScope.globals.selectedDrink.category_icon = category_icon;

            // check if drink has options
            if( Drink.checkIfSelectedDrinkHasOptions() ){

                ngDialog.open({
                        template   : 'views/partials/drink-options.html',
                        controller : 'DrinkOptionsController',
                        className  : 'ngdialog-drink-options',
                        closeByNavigation : true,
                    })
                    .closePromise.then(function (data) {
                        if( data.value == 'submited' ){
                            // remember users selection after browser refresh
                            Helper.updateLocalStorageWithGlobalVariable();
                            
                            // redirect
                            $timeout(function(){
                                $location.path('/drink-cart');
                            }, 500);
                        }
                    });
            }
            else{
                // remember users selection after browser refresh
                Helper.updateLocalStorageWithGlobalVariable();

                // redirect
                $location.path('/drink-cart');
            }
    	}


        /**
         * function is called when user
         * opens/closes drink category
         * 
         * @param  Object  category
         */
        $scope.toggleCategory = function(category, event){

            if( typeof category.expanded == 'undefined' )   category.expanded = true;
            else                                            category.expanded = ! category.expanded;

            
            // jQuery :(
            var element = $(event.currentTarget).closest('.category-item');

            if( category.expanded ){
                var inner_group_height = element.find('.list-group').height() + 120;

                element.css('max-height', inner_group_height);
                element.find('.toggle-category-btn').addClass('expanded');

                if( $('.toggle-category-btn.expanded img.with-effect').length ){
                    // yep, the img still exists
                    Caman('.toggle-category-btn.expanded img.with-effect', function () {
                        this.colorize('#F3564B', 100).render();
                    });
                }
            }
            else{
                element.css('max-height', 74);
                element.find('.toggle-category-btn').removeClass('expanded');
            }
        }


    	// init first api call
    	$scope.getDrinks();
    }]);